import { useEffect, useState } from "react";
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setVisible(true);
  }, []);

  const handleChoice = (value) => {
    localStorage.setItem("cookieConsent", value); // "accepted" | "declined"
    setVisible(false);
  };



function web() {
  const fileName = "/web.pdf#toolbar=0";
  window.open(fileName, "_blank");
}

function openPdf() {
  window.open("/web.pdf#toolbar=0", "_blank");
}
  if (!visible) return null;

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.textBox}>
          <strong style={styles.title}>שימוש בעוגיות (Cookies)</strong>
          <p style={styles.text}>
            באתר זה נעשה שימוש ב"קבצי עוגיות" (cookies) לשיפור חוויית המשתמש,
            ניתוח תנועה והתאמת תוכן. ניתן לאשר או לסרב.
            {" "}
     <Link to="/privacy-policy" onClick= {web} style={styles.link}>
  למדיניות הפרטיות
</Link>
          </p>
        </div>

        <div style={styles.actions}>
          <button
            onClick={() => handleChoice("declined")}
            style={{ ...styles.button, ...styles.decline }}
          >
            סירוב
          </button>

          <button
            onClick={() => handleChoice("accepted")}
            style={{ ...styles.button, ...styles.accept }}
          >
            אישור
          </button>
        </div>
      </div>
    </div>
  );
}


const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    // pointerEvents: "none" מאפשר ללחוץ על האתר מסביב, אבל דורש תיקון בתוך ה-card
    pointerEvents: "none", 
  },
card: {
  maxWidth: "700px",
  width: "90%",
  background: "#1f2937",
  color: "#fff",
  borderRadius: "12px",
  padding: "20px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  direction: "rtl",
  pointerEvents: "auto",
  textAlign: "center", // מרכז את הטקסט
},

textBox: {
  lineHeight: 1.5,
  textAlign: "center",
},

  title: {
    display: "block",
    fontSize: "16px",
    marginBottom: "6px",
  },
  text: {
    margin: 0,
    fontSize: "14px",
    color: "#d1d5db",
  },
  link: {
    color: "#60a5fa",
    textDecoration: "underline",
  },

actions: {
  display: "flex",
  justifyContent: "center",
  gap: "10px",
  flexDirection: "row-reverse",
},
  button: {
    border: "none",
    padding: "8px 14px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    // הוספת pointerEvents ליתר ביטחון לכפתורים
    pointerEvents: "auto",
  },
  accept: {
    backgroundColor: "#22c55e",
    color: "#fff",
  },
  decline: {
    backgroundColor: "#374151",
    color: "#fff",
  },
};